/* tslint:disable */
/* eslint-disable */
/**
 * partnerDriverWeb driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationLogStatus } from './DriverRegistrationLogStatus';
import type { DriverRegistrationLogSource } from './DriverRegistrationLogSource';

export interface GetActualDriverRegistrationResponse {
    hash: string;
    status: DriverRegistrationLogStatus;
    /** 2 char country code, for example: \'us\', \'ee\', \'gb\' */
    country: string | null;
    /** min length: 0, max length: 255 */
    city: string | null;
    city_id: number | null;
    flow_id: number | null;
    source?: DriverRegistrationLogSource;
}
